<template>
    <div class="flex justify-center text-center">
        <ul class="inline-flex">
            <li v-for="(item, itemIndex) in navData" :key="itemIndex" class="mx-3 my-0 font-head font-semibold text-base text-white">
                <a v-if="item.groups.length || item.children.length" class="group" :href="item.url" @click.prevent="setSelectedItemIndex(itemIndex)" :title="item.title" v-text="item.title"></a>
                <a v-else class="cursor-pointer" :href="item.url" :title="item.title" v-text="item.title"></a>
            </li>
        </ul>
    </div>
</template>
<script>
    import {mapState, mapMutations} from 'vuex'

    export default {
        computed: {
            ...mapState('navigation', {
                navData:'navData'
            })
        },
        methods: {
            ...mapMutations('navigation',[
                'setSelectedItemIndex'
            ])
        }
    }
</script>
<style lang="scss" scoped>
    .group {
        background-image: url('/img/down-arrow.svg');
        background-position: right;
        background-repeat: no-repeat;
        padding-right: 20px;
        background-size: 12px;
    }
</style>